<template>
  <v-chord
    :songs="songs"
    :artist="artist.id"
    direction="source"
  />
</template>

<script>

import Chord from "@/components/Chord";
import { sourceSongs } from "@/services/filters";

export default {
	components: {
		"v-chord": Chord
	},
	props: {
		artist: {
			required: true,
			type: Object
		}
	},
	computed: {
		songs () {
			return sourceSongs(this.artist);
		}
	}
};
</script>
